//Library imports
import styled, { css } from 'styled-components';
import { Card, Col, Divider, Modal, Popover, Radio, Row, Space, Spin, Tag, Tooltip, Typography } from 'antd';
import { useState } from 'react';

//Local imports
import { ReactComponent as Audience } from '../../../assets/img/icons/Audience.svg';
import { ReactComponent as OpenEmail } from '../../../assets/img/icons/Open_Email.svg';
import { ReactComponent as Send } from '../../../assets/img/icons/Send (5).svg';
import { ReactComponent as Eye } from '../../../assets/img/icons/eye.svg';
import { ReactComponent as Click } from '../../../assets/img/icons/Click.svg';
import { ReactComponent as Analytics } from '../../../assets/img/icons/nav/analytics.svg';
import { ReactComponent as Flow } from '../../../assets/img/icons/nav/Flow.svg';
import { ReactComponent as Resend } from '../../../assets/img/icons/resend.svg';
import CalendarDiv from '../../Common/CalendarDiv';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { GILL_HAPPY_FACE, IMAGE_SERVICE_URL } from '../../../constants/index';
import store, { RootState } from 'store';
import { ALL_ARTICLES_IN_EDITION, DESIGN } from 'constants/actionTypes';
import { getEditionArticles } from '../Edition/actions';
import { EMAIL_LIST } from 'constants/types';
import GillRoyBotIcon from 'assets/svgs/GillRoyBotIcon';
import classNames from 'classnames';
import PersonalityPill from './PersonalityPill';
import { getQueryWorkflowId } from 'modules/EmailBrowser/utils';
import { resendOptions } from '../Emails/actions';
import { useSelector } from 'react-redux';
import InfoPopover from 'modules/Common/Components/InfoPopover';
const { Text } = Typography;
const SharedCard = (props: any) => {
  const {
    emailType,
    scheduled_time,
    isScheduled = false,
    data,
    sent_date,
    sent_month,
    campaignId,
    showEmailStats,
    scheduledStyle = false,
    automation,
    tabState,
    aiTag,
    generationId,
    collapse,
    month,
    date,
    children,
    parentCollapse,
    childCollapse,
    aiColor,
    parentLinear,
    childColor,
    isWorkflowEmailsList,
  } = props;

  const history = useHistory();

  const [resendOption, setResendOption] = useState(1);
  const [showResendModal, setShowResendModal] = useState(false);
  const [ellipsis, setEllipsis] = useState(true);

  const resendLoading = useSelector((state: RootState) => state.emails.resendLoading);

  const getAIEmailIds = () => {
    const aiEmailIds = data?.ai_emails.map((aiEmail: any) => aiEmail.version_id);
    return aiEmailIds.join(',');
  };

  const sentEmailOptions = [
    {
      name: 'Resend Options',
      onClick: () => {
        setShowResendModal(true);
      },
      icon: <Resend />,
      hide: !!aiTag,
      disable: automation || data?.status === 'Scheduled',
      tooltipText: automation ? 'Resend this email by cloning it through "Save As" button in Design Studio.' : '',
    },
    {
      name: 'View Analytics',
      onClick: () => {
        window.open(
          `/analytics?campaign_id=${campaignId}&email_id=${
            parentCollapse && data?.ai_emails?.length > 0 ? getAIEmailIds() + '&ai_email=true' : data?.version_id
          }`,
          '_blank',
        );
      },
      icon: <Analytics />,
      hide: false,
      disable: data?.status === 'Draft' || data?.status === 'Error' || data?.status === 'Scheduled',
      tooltipText: '',
    },
    {
      name: 'View Workflow',
      onClick: () => {
        window.open(`/automation/details?workflow_id=${data?.workflow_id}&campaign_id=${campaignId}`, '_blank');
      },
      icon: <Flow />,
      hide: !automation,
      disable: false,
      tooltipText: '',
    },
  ];

  return (
    <Card
      id={data?.version_id}
      bodyStyle={{ width: '100%' }}
      className={classNames(`card-style ${scheduledStyle ? 'card-style-scheduled' : ''}`, {
        parentAppend: parentCollapse,
        childAppend: childCollapse,
      })}
    >
      <Row>
        <Col span={14} lg={12}>
          <LeftSide
            color={parentLinear}
            childrenColor={childColor}
            className="left-side-image"
            onClick={() => {
              store.dispatch({ type: DESIGN.RESET_DESIGN });
              store.dispatch({ type: ALL_ARTICLES_IN_EDITION.RESET_ALL_DATA });
              getEditionArticles(data?.version_id);
              let url = `/campaigns/editionedit/publish/?campaign_id=${campaignId}&email_id=${data?.version_id}`;
              if (generationId) url = url + `&generation_id=${generationId}`;
              if (isWorkflowEmailsList) url = url + `&from=workflow-email-listing&workflow_id=${getQueryWorkflowId()}`;
              history.push(url);
            }}
          >
            <CalendarDiv color={`${scheduledStyle ? 'Green' : 'Grey'}`} date={sent_date} month={sent_month} />
            <div className="color-strip clickable"></div>
            <div className="image-wrapper">
              <img
                className="image-resize clickable"
                alt=""
                src={
                  data?.thumbnail[0] || IMAGE_SERVICE_URL + '/returnimage/?url=&width=95&height=95&articleid=357964118&detectface=true&app_name=wb'
                }
                onError={(e: any) => {
                  e.target.onerror = null;
                  e.target.src = IMAGE_SERVICE_URL + '/returnimage/?url=&width=95&height=95&articleid=357964118&detectface=true&app_name=wb';
                }}
              ></img>
              <div
                className={`image-background image-resize clickable ${
                  emailType === 2 && data?.thumbnail?.length > 1 && parentCollapse ? 'count-email' : ''
                }`}
                style={{
                  backgroundImage: `url(${
                    data?.thumbnail[0] || IMAGE_SERVICE_URL + '/returnimage/?url=&width=95&height=95&articleid=357964118&detectface=true&app_name=wb'
                  })`,
                }}
              >
                {data?.is_test ? <Tag className={`styling-tag test-tag`}>{data?.is_test === 'Test' ? 'Test' : ''}</Tag> : <> </>}
                {emailType === 2 && data?.thumbnail?.length > 1 && parentCollapse ? (
                  <span className="count">+{data?.thumbnail?.length - 1}</span>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="text-area">
              {childCollapse ? (
                <div className="per">
                  <div>
                    <PersonalityPill title={aiTag} />
                  </div>
                  <div className="subject d-flex">
                    <span className="subject-label ml-10">Subject: </span>
                    <Text ellipsis={ellipsis ? { tooltip: data?.subject } : false}>{data?.subject}</Text>
                  </div>
                </div>
              ) : (
                <>
                  <div className="article-text-style clickable text-truncate" data-id="name-of-edition">
                    <Text ellipsis={ellipsis ? { tooltip: data?.name } : false}>{data?.name}</Text>
                  </div>
                  {emailType !== 2 ? (
                    <div className="subject d-flex">
                      <span className="subject-label ml-10">Subject: </span>
                      <Text ellipsis={ellipsis ? { tooltip: data?.subject } : false}>{data?.subject}</Text>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              )}
              {data?.sent_by.trim() !== '' && scheduledStyle ? (
                <div className="grey-text ">
                  {`Scheduled by: `}
                  <span className="green-mail-text" data-id="email-of-edition-sender">
                    {data?.sent_by}
                  </span>
                </div>
              ) : data?.sent_by ? (
                <div className="grey-text ">
                  {`Sent by: `}
                  <span className="green-mail-text" data-id="email-of-edition-sender">
                    {data?.sent_by}
                  </span>
                </div>
              ) : (
                <></>
              )}
              <div className="grey-text ">
                {isScheduled ? `Sends in: ` : ``}
                {isScheduled ? <b>{scheduled_time}</b> : data?.sent_date ? `${data?.sent_date}` : ''}
              </div>
            </div>
          </LeftSide>
        </Col>
        <Col span={10} lg={12}>
          <RigthSide className="right-parent-div">
            <div className="icons-tags-div">
              <div className="tags-container">
                {emailType === 2 && !childCollapse && <Tag className="styling-tag email-tag">AI Email</Tag>}
                <Tag className={`${data?.status === 'Error' ? 'error-tag' : ''} styling-tag email-tag`}>{data?.status}</Tag>
              </div>
              {showEmailStats && (
                <div className="d-flex" style={{ gap: '16px', textAlign: 'center' }}>
                  <Tooltip placement="top" title="Total Contacts">
                    <span className="icon-span">
                      <span className={`icon-styling ${data?.total_contacts ? '' : 'disabled'}`}>
                        <a
                          href={`/audiences/contacts?${
                            parentCollapse && data?.ai_emails?.length > 0
                              ? 'generation_id=' + generationId
                              : 'sent_emails=true&email_id=' + data?.version_id
                          }`}
                          target="_blank"
                        >
                          <Audience className={`${data?.total_contacts > 0 ? '' : 'disabled'}`} />
                          <span className={`${data?.total_contacts > 0 ? '' : 'disabled'} icon-text-styling`}>{data?.total_contacts || 0}</span>
                        </a>
                      </span>
                    </span>
                  </Tooltip>
                  <Tooltip placement="top" title="Emails Sent">
                    <span className="icon-span">
                      <span className={`icon-styling ${data?.total_sent ? '' : 'disabled'}`}>
                        <div className="d-flex flex-column">
                          <Send className={`${data?.total_sent > 0 ? '' : 'disabled'}`} />
                          <span className={`icon-text-styling ${data?.total_sent > 0 ? '' : 'disabled'}`}>{data?.total_sent || 0}</span>
                        </div>
                      </span>
                    </span>
                  </Tooltip>
                  <Tooltip placement="top" title="Emails Delivered">
                    <span className="icon-span">
                      <span className={`icon-styling ${data?.total_delivery ? '' : 'disabled'}`}>
                        <a
                          href={`/analytics/contacts/delivered?campaign_id=${campaignId}&email_id=${
                            parentCollapse && data?.ai_emails?.length > 0 ? getAIEmailIds() + '&ai_email=true' : data?.version_id
                          }`}
                          target="_blank"
                        >
                          <OpenEmail className={`${data?.total_delivery > 0 ? '' : 'disabled'}`} />
                          <span className={`icon-text-styling ${data?.total_delivery > 0 ? '' : 'disabled'}`}>{data?.total_delivery || 0}</span>
                        </a>
                      </span>
                    </span>
                  </Tooltip>
                  <Tooltip placement="top" title="Total Opens">
                    <span className="icon-span">
                      <span className={`icon-styling eye ${data?.total_open ? '' : 'disabled'}`}>
                        <a
                          href={`/analytics/contacts/delivered?campaign_id=${campaignId}&email_id=${
                            parentCollapse && data?.ai_emails?.length > 0 ? getAIEmailIds() + '&ai_email=true' : data?.version_id
                          }&opens=true`}
                          target="_blank"
                        >
                          <Eye className={`${data?.total_open > 0 ? '' : 'disabled'}`} />
                          <span className={`icon-text-styling ${data?.total_open > 0 ? '' : 'disabled'}`}>{data?.total_open || 0}</span>
                        </a>
                      </span>
                    </span>
                  </Tooltip>
                  <Tooltip placement="top" title="Total Clicks">
                    <span className="icon-span">
                      <span className={`icon-styling ${data?.total_clicks ? '' : 'disabled'} `}>
                        <a
                          href={`/analytics/contacts/delivered?campaign_id=${campaignId}&email_id=${
                            parentCollapse && data?.ai_emails?.length > 0 ? getAIEmailIds() + '&ai_email=true' : data?.version_id
                          }&clicks=true`}
                          target="_blank"
                        >
                          <Click className={`${data?.total_clicks > 0 ? '' : 'disabled'}`} />
                          <span className={`icon-text-styling ${data?.total_clicks > 0 ? '' : 'disabled'}`}>{data?.total_clicks || 0}</span>
                        </a>
                      </span>
                    </span>
                  </Tooltip>
                  {isWorkflowEmailsList && (
                    <div className="analytics-icon-div">
                      {showEmailStats && (
                        <Tooltip placement="top" title="Analytics" className="tooltip-div-wrapper">
                          <span>
                            <a
                              className={
                                data?.status === 'Draft' || data?.status === 'Error' || data?.status === 'Scheduled'
                                  ? 'disable-link analytics-btn'
                                  : 'analytics-btn'
                              }
                              href={`/analytics?campaign_id=${campaignId}&email_id=${
                                parentCollapse && data?.ai_emails?.length > 0 ? getAIEmailIds() + '&ai_email=true' : data?.version_id
                              }`}
                              target="_blank"
                              // commenting this because now we are redirecting into new tab
                              // onClick={() => {
                              //   window.scrollTo(0, 0);
                              //   localStorage.setItem('analytics_back_url', window.location.pathname + window.location.search);
                              //   store.dispatch({ type: EMAIL_LIST.SET_TAB_STATE, payload: { tabState: tabState } });
                              // }}
                            >
                              <Analytics />
                            </a>
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
            {!isWorkflowEmailsList && (
              <>
                <div className="resend-divider">
                  <Divider type="vertical" style={{ margin: '0 16px' }} />
                </div>
                <div className="sent-email-options">
                  {sentEmailOptions.map((option, index) => {
                    return (
                      !option.hide && (
                        <Popover
                          content={option.tooltipText}
                          overlayInnerStyle={{
                            color: 'rgba(0, 0, 0, 0.85)',
                            fontFamily: 'Roboto',
                            fontSize: '16px',
                            fontWeight: 500,
                            lineHeight: 'normal',
                            width: '270px',
                            boxShadow: '0px 2px 60px 0px rgba(0,0,0,0.35)',
                            borderRadius: 10,
                            // padding: '16px'
                          }}
                          showArrow={!!option.tooltipText}
                          placement="rightTop"
                        >
                          <>
                            <div key={index} className={classNames('option', { disabled: option.disable })} onClick={() => option.onClick()}>
                              {option.icon}
                              {option.name}
                            </div>
                          </>
                        </Popover>
                      )
                    );
                  })}
                </div>
              </>
            )}
          </RigthSide>
        </Col>
      </Row>
      <ResendOptionsModal open={showResendModal} centered width="582px" className="reference-message-modal">
        <img src={GILL_HAPPY_FACE} alt="gill-data" className="happy-face-gill" />
        {resendLoading ? (
          <>
            <h4 className="heading-loading-popup">Please wait while we clone your email...</h4>
            <Spin style={{ marginTop: '65px', marginBottom: '73px' }} size="large" spinning={resendLoading} />
          </>
        ) : (
          <>
            <h4 className="heading-loading-popup">
              A clone of this email will be created, enabling you to make design changes and edit your audience and publish options before resending.
            </h4>
            <Radio.Group className="radio-group" onChange={(e) => setResendOption(e.target.value)} value={resendOption}>
              <Space direction="vertical">
                <Radio value={1} className="options">
                  Send to new or existing contacts
                </Radio>
                <Radio value={2} className="options">
                  <span className="d-flex align-items-center">
                    Send to contacts who have not opened this email{' '}
                    <InfoPopover
                      className="info-popover-class"
                      placement="bottomLeft"
                      infoText={
                        'If your email open rate reaches 100%, it means all recipients have opened it, and as a result, no contacts will be associated with the email.'
                      }
                      width={300}
                    />
                  </span>
                </Radio>
              </Space>
            </Radio.Group>
            <div className="actions">
              <span className="action-trigger no" onClick={() => setShowResendModal(false)}>
                Cancel
              </span>
              <span className="action-trigger yes" onClick={() => resendOptions(resendOption, history, campaignId, data?.version_id, generationId)}>
                Continue
              </span>
            </div>
          </>
        )}
      </ResendOptionsModal>
    </Card>
  );
};

export default SharedCard;

SharedCard.defaultProps = {
  showEmailStats: true,
};

export const footerAction = css`
  .actions {
    .action-trigger {
      border-radius: 18px;
      border: 2px solid #1ec252;
      background-color: #1ec252;
      color: #fff;
      text-align: center;
      font-family: 'Roboto';
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      width: 80px;
      display: inline-block;
      padding: 6px;
      cursor: pointer;

      &:nth-child(1) {
        background-color: #fff;
        color: #1ec252;
        margin-right: 8px;
      }
    }
  }
`;

const ResendOptionsModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 18px;
    text-align: center;

    .ant-modal-footer,
    .ant-modal-close-x {
      display: none !important;
    }
    .ant-modal-body {
      padding: 50px;
      height: 486px;
      h4.heading-loading-popup {
        font-family: 'Roboto slab';
        font-size: 26px;
        letter-spacing: -0.8;
        line-height: normal;
        color: #424b50;
        font-weight: 700;
        margin: 10px 0px 20px 0px;
      }
      .options {
        color: #424b50;
        font-family: 'Roboto';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 26px;
        .info-popover-class {
          height: 16px;
          margin-left: 8px;
        }
      }
      ${footerAction};
      .actions {
        .action-trigger {
          width: auto;
          padding: 6px 16px;
        }
        .disabled {
          pointer-events: none;
          opacity: 0.5;
        }
        margin-top: 25px;
      }
      .option {
        font-family: 'Roboto';
        font-size: 16px;
        font-weight: 500;
      }
    }
    .ant-modal-footer {
      display: flex;
      justify-content: center;
      flex-direction: row-reverse;
    }
  }
  .radio-group {
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 500;
    text-align: left;
  }
`;

const LeftSide = styled.div<{ color: string; childrenColor: string }>`
  display: flex;
  align-items: center;
  .personality-pill {
    position: relative;
    top: 0;
    left: 0;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  .sent-date-title {
    padding-top: 5px;
    padding-left: 10px;
    font-family: 'robotoregular', sans-serif;
    font-size: 14px;
    color: #67696a;
  }
  .icon-spacing {
    .icon-span {
      display: flex;
      align-items: flex-end;
      height: 100%;
    }
  }
  .menu-item-align {
    text-align-last: end;
    margin: 1em 0.45em 0 0;
  }
  .status-area {
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  }
  .color-strip {
    background: ${(props) => props.color};
    background-color: ${(props) => props.childrenColor};
  }
  .count-email {
    position: relative;
    .count {
      height: 40px;
      width: 50px;
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      right: 0px;
      bottom: 0px;
      color: #fff;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Roboto slab';
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 30px;
        width: 30px;
      }
    }
  }
`;
const RigthSide = styled.div`
  display: flex;
  justify-content: end;
  height: 100%;
  .icons-tags-div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .icon-span {
    margin: auto;
  }
  .resend-divider {
    .ant-divider-vertical {
      border-left: 1px solid #cacaca;
      height: 100%;
      max-height: 97px;
    }
  }
  .sent-email-options {
    color: #667982;
    font-family: 'Roboto';
    font-size: 12px;
    font-weight: 700;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    max-width: 108px;
    width: 100%;
    @media all and (max-width: 1200px) {
      width: 90%;
    }
    .resend-popover {
      width: 350px;
      background: transparent;
      border-radius: 15px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 340px;
      }
      .ant-popover-content {
        .ant-popover-arrow {
          right: 3px;
          top: 5px;
          width: 15px;
          height: 15px;
          border-width: 7px;
          left: 91% !important;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            left: 67% !important;
          }
        }
        .ant-popover-inner {
          border-radius: 15px;
          .ant-popover-inner-content {
            padding: 16px 21px 16px 16px;
            color: #5e7079;
            font-size: 12px;
            font-weight: 500;
            font-style: normal;
            font-family: 'Roboto';
            letter-spacing: -0.395062px;
            line-height: 14px;
            border-radius: 15px;
            box-shadow: 0px 2px 60px 0 rgb(0 0 0 / 28%);
          }
        }
      }
    }
    .option {
      cursor: pointer;
    }
    svg {
      width: 16px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 15px;
      }
      height: auto;
      margin-right: 6px;
      margin-bottom: 4px;
      g {
        fill: #27ce0a;
      }
    }
  }
  .analytics-icon-div {
    display: flex;
    align-items: end;
    margin-bottom: 4.5px;
  }
`;
